import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalDataService } from './../../shared/global-data';
import { distinctUntilChanged } from 'rxjs/operators';
import { StorageMap } from '@ngx-pwa/local-storage';

@Component({
  selector: 'app-financial-wellness',
  templateUrl: './financial-wellness.component.html',
  styleUrls: ['./financial-wellness.component.css']
})
export class FinancialWellnessComponent implements OnInit {

  constructor(private router: Router, private globalData: GlobalDataService, 
		private lsService: StorageMap) {
	}

  ngOnInit(): void {
    this.globalData.changeCurrentViewState('financial');
  }

  loadModal(type){
    this.globalData.changeCurrentModalState(type);
	}

}
